import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';

// API URL: Use environment variable if set, otherwise use same hostname with /api prefix
// This works for both local dev (localhost:3000) and production (behind Traefik with /api)
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Use same hostname as frontend, with /api prefix for backend (Traefik routing)
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // If on standard ports (80/443), use /api prefix (Traefik routing)
  // Otherwise, use port 3000 for local development
  if (port === '' || port === '80' || port === '443') {
    return `${protocol}//${hostname}/api`;
  }
  return `${protocol}//${hostname}:3000`;
};

const API_URL = getApiUrl();

// Log API URL for debugging
console.log('Frontend API URL:', API_URL);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authToken, setAuthToken] = useState<string | null>(null);

  useEffect(() => {
    // Check if user is already authenticated
    const token = localStorage.getItem('authToken');
    if (token) {
      setAuthToken(token);
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (token: string) => {
    localStorage.setItem('authToken', token);
    setAuthToken(token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setAuthToken(null);
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} apiUrl={API_URL} />;
  }

  return <Dashboard onLogout={handleLogout} apiUrl={API_URL} authToken={authToken!} />;
}

export default App;
